import React from "react";

export function DaigasFooter(props) {
  return (
    <div className="daigas-content-footer">
      COPYRIGHT © SAKIMESHI. ALL RIGHTS RESERVED.
    </div>
  );
}
